import React from 'react'
import { Globe } from 'lucide-react'
import { useLanguage } from '../i18n'

const LanguageSwitcher = () => {
  const { language, toggleLanguage } = useLanguage()

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-slate-800/50 border border-titanium-gold/30 hover:border-titanium-gold/60 hover:bg-slate-700/50 transition-all duration-300"
      title={language === 'zh' ? 'Switch to English' : '切换到中文'}
    >
      <Globe className="w-4 h-4 text-titanium-gold" />
      <span className="text-sm font-medium text-white">
        {language === 'zh' ? 'EN' : '中'}
      </span>
    </button>
  )
}

export default LanguageSwitcher
